const toneByStatus = {
  Live: "border-emerald-400/20 bg-emerald-400/8 text-emerald-300",
  Beta: "border-accent/25 bg-accent/10 text-accentSoft",
  Building: "border-amber-300/20 bg-amber-300/8 text-amber-200",
  Planned: "border-border bg-surface/60 text-secondary",
  Research: "border-sky-300/20 bg-sky-300/8 text-sky-200",
  "Coming Soon": "border-border bg-surface/60 text-secondary"
};

function StatusBadge({ status }) {
  return (
    <span
      className={`inline-flex h-6 items-center rounded-full border px-2.5 text-xs font-medium transition-all duration-200 ease-in-out ${
        toneByStatus[status] || toneByStatus.Planned
      }`}
    >
      {status}
    </span>
  );
}

export default StatusBadge;
